/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../../shared/qrequest";
import L from "../Lang"
import BaseCom from "../BaseCom";
import { Pop } from "../PopModal";

export default class VisitBaseCom extends BaseCom {
    showConfirmClaim = (callback, cancelCallback) => {
        let visit = this.state.visit || this.props.visit;
        Pop.showConfirm('Adding input to this visit will automatically claim the visit for you. Are you sure you want to proceed?', 'Claim Visit', () => {
            qreq.post('/api/visit/claim', visit, j => {
                if (j.errorCode === 0) {
                    callback();
                }
                else
                    this.alert(j.errorMessage);
            }, this.unkownErrorCallback);
        }, () => {
            cancelCallback?.();
        });
    }
}